// 登录
const state = {
  _axiosPromiseCancel: []
}
const getters = {
  _axiosPromiseCancel: loginState => loginState._axiosPromiseCancel
}
const mutations = {
  setAxiosPromiseCancel (loginState, data) {
    loginState._axiosPromiseCancel = data || []
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js